/** @jsx h */
import { h } from 'preact'

import ExternalLink from '../ExternalLink'
import t from '../../../utils/translate'

const BlockchainProofSection = ({ url, hash, recordType, analyticsContext }) =>
  <section class='ModalCard-section'>
    <h2 class='ModalCard-heading'>
      {t('proof_points.js.proof.see_record')}
    </h2>
    <p class='ModalCard-para u-marginTop8'>
      {t('proof_points.js.proof.view_permanent', { recordType })}:
    </p>
    <ExternalLink href={url} linkName={t('proof_points.js.proof.view_claim')} analyticsContext={analyticsContext}>
      {hash.substring(0, 16)}…
    </ExternalLink>
  </section>

BlockchainProofSection.defaultProps = {
  recordType: 'claim'
}

export default BlockchainProofSection
